export enum CommonLandingPageSteps {
    GENERAL = "GENERAL",
    TEMPLATE = "TEMPLATE",
    CONNECTIONS = "CONNECTIONS",
    PAYWALL_INTEGRATION = "PAYWALL_INTEGRATION",
    PAGE_CONTENT = "PAGE_CONTENT",
    PREVIEW_AND_LAUNCH = "PREVIEW_AND_LAUNCH",
}

export const AddLandingPageSteps = {
    ...CommonLandingPageSteps,
} as const;

export const EditLandingPageSteps = {
    OVERVIEW: "OVERVIEW",
    ...CommonLandingPageSteps,
} as const;

export const AddFunnelSteps = {
    GENERAL: "GENERAL",
    TEMPLATE: "TEMPLATE",
    CONNECTIONS: "CONNECTIONS",
    PAYWALL_INTEGRATION: "PAYWALL_INTEGRATION",
    PAGE_CONTENT: "PAGE_CONTENT",
    FUNNEL: "FUNNEL",
    PREVIEW_AND_LAUNCH: "PREVIEW_AND_LAUNCH",
} as const;

export const EditFunnelSteps = {
    OVERVIEW: "OVERVIEW",
    GENERAL: "GENERAL",
    TEMPLATE: "TEMPLATE",
    CONNECTIONS: "CONNECTIONS",
    PAYWALL_INTEGRATION: "PAYWALL_INTEGRATION",
    PAGE_CONTENT: "PAGE_CONTENT",
    FUNNEL: "FUNNEL",
    PREVIEW_AND_LAUNCH: "PREVIEW_AND_LAUNCH",
} as const;

export const STEPS = {
    [EditLandingPageSteps.OVERVIEW]: {
        label: "Overview",
        key: EditLandingPageSteps.OVERVIEW,
    },
    [CommonLandingPageSteps.GENERAL]: {
        label: "General",
        key: CommonLandingPageSteps.GENERAL,
    },
    [CommonLandingPageSteps.TEMPLATE]: {
        label: "Template",
        key: CommonLandingPageSteps.TEMPLATE,
    },
    [CommonLandingPageSteps.CONNECTIONS]: {
        label: "Connections",
        key: CommonLandingPageSteps.CONNECTIONS,
    },
    [CommonLandingPageSteps.PAYWALL_INTEGRATION]: {
        label: "Paywall Integration",
        key: CommonLandingPageSteps.PAYWALL_INTEGRATION,
    },
    [CommonLandingPageSteps.PAGE_CONTENT]: {
        label: "Page Content",
        key: CommonLandingPageSteps.PAGE_CONTENT,
    },
    [CommonLandingPageSteps.PREVIEW_AND_LAUNCH]: {
        label: "Preview & Launch",
        key: CommonLandingPageSteps.PREVIEW_AND_LAUNCH,
    },
    ["FUNNEL"]: {
        label: "Funnel Builder",
        key: "FUNNEL",
    },
};

export interface AddEditLandingPageOwnProps {
    landingPageForm: object;
    landingPageFormStep: AddEditLandingPageStateProps;
    language: any;
}

export interface AddEditLandingPageStateProps {}

export interface AddEditLandingPageDispatchProps {
    dispatchSetFormStep: (step) => void;
    dispatchGetTemplates: () => void;
    dispatchClearState: () => void;
}

export type AddEditLandingPageProps = AddEditLandingPageOwnProps &
    AddEditLandingPageStateProps &
    AddEditLandingPageDispatchProps;
